import Skeleton from '@mui/material/Skeleton';

export default function PreloaderTable(props) {
    const rows = [1,2,3,4,5,6]
    return <div>
        {(props.rows || rows).map(i => <Skeleton key={`preloader_table_item_${i}`} variant="rectangular" width={'100%'} height={50} style={{marginBottom: '1rem'}} />)}
    </div>
}
